/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconZodiacTaurus = createReactComponent("zodiac-taurus", "IconZodiacTaurus", [
  ["path", { d: "M6 3a6 6 0 0 0 12 0", key: "svg-0" }],
  ["path", { d: "M12 15m-6 0a6 6 0 1 0 12 0a6 6 0 1 0 -12 0", key: "svg-1" }]
]);

export { IconZodiacTaurus as default };
//# sourceMappingURL=IconZodiacTaurus.js.map
